<ion-item button>
  <ion-avatar slot="start" *ngIf="user?.profile_image">
    <img style="width: auto" [src]="user?.profile_image" />
  </ion-avatar>

  <ion-avatar slot="start" *ngIf="!user?.profile_image">
    <img class="avatarImage" [src]="avatarImage" />
  </ion-avatar>

  <ion-label>
    {{ user.first_name }} {{ user.last_name }}
    <p>{{ getSex() }}</p>
  </ion-label>

  <ion-button slot="end" [fill]="!isOwner ? 'outline' : 'solid'" class="follow-badge" *ngIf="showApprove"
    (click)="onPrimaryClick($event)">
    {{ primaryText }}
  </ion-button>
</ion-item>